class AnchorScroll {
  constructor(el) {
    this.dom = {el: el};
    this.dom.header = null;

    this.hash = null;
    this.scroll = this.scroll.bind(this);

    this.init();
  }

  init() {
    const href = this.dom.el.getAttribute('href');
    
    // ハッシュの安全な抽出
    const hashMatch = href.match(/\#.*$/);
    if (!hashMatch) return;
    
    this.hash = hashMatch[0];
    if (this.hash.length > 1) {
      this.dom.el.addEventListener('click', this.scroll);
    }
  }

  scroll(e) {
    e.preventDefault();

    // pagetopの場合は最上部にスクロール
    if (/pagetop/.test(this.hash) || this.hash === '#') {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      return;
    }

    const target = document.querySelector(this.hash);
    if (!target) return;

    // ヘッダーの高さを動的に取得
    let headerHeight = 0;
    if (this.dom.header) {
      headerHeight = this.dom.header.offsetHeight;
    }

    // 追加のオフセット（余白）
    const additionalOffset = 0;
    const totalOffset = headerHeight + additionalOffset;

    // 現在のスクロール位置を取得
    const currentScrollY = window.scrollY || window.pageYOffset;
    
    // ターゲット要素の位置を取得
    const targetRect = target.getBoundingClientRect();
    const targetTop = targetRect.top + currentScrollY;
    
    // 最終的なスクロール位置を計算
    const scrollToPosition = Math.max(0, targetTop - totalOffset);

    window.scrollTo({
      top: scrollToPosition,
      behavior: 'smooth'
    });
  }

  destroy() {
    this.dom.el.removeEventListener('click', this.scroll);
  }
}

export default AnchorScroll